import { ErrorSummary, InlineErrorMessage, Label } from '@atoms/Label/Label';
import {
  RadioOptions,
  RadioOptionsProps,
} from '@molecules/RadioOptions/RadioOptions';
import { ErrorMessages } from '@types';

export type MultipleRadioOptionsWithoutImagesProps = {
  pageTitle: string;
  radioOptions: RadioOptionsProps[];
  errorMessages: ErrorMessages[];
  errorPath: string;
};

export function MultipleRadioOptionsWithoutImages(
  props: MultipleRadioOptionsWithoutImagesProps,
) {
  return (
    <form className="mb-1 mt-4 flex flex-col gap-2">
      <ErrorSummary messages={props.errorMessages} />
      <Label
        className={`!text-brand-primary body-2 text-h2`}
        htmlFor={props.pageTitle}
        text={props.pageTitle}
        isTitle={true}
      />
      <div className="mt-3 flex flex-col gap-6">
        {props.radioOptions.map((radioOption) => (
          <RadioOptions
            key={radioOption.title}
            title={radioOption.title}
            description={radioOption.description}
            errorPath={radioOption.errorPath}
            errorMessages={props.errorMessages}
            onChange={radioOption.onChange}
            options={radioOption.options}
            isLabelTextTitle={false}
          />
        ))}
      </div>
    </form>
  );
}

export default MultipleRadioOptionsWithoutImages;
